export default "__VITE_ASSET__bQElxwlr__"